import wsmLogoDark from "@assets/images/wsm-logo-dark.png";
import wsmLogoLight from "@assets/images/wsm-logo-light.png";
import { Box } from "@material-ui/core";
import { makeStyles, useTheme } from "@saleor/macaw-ui";
import React, { ReactNode } from "react";

import { useUser } from "..";
import LoginLoading from "./LoginLoading";

const useStyles = makeStyles(
  theme => ({
    logo: {
      display: "block",
      height: 40,
      marginBottom: theme.spacing(4),
    },
    mainPanel: {
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
      },
      background: theme.palette.background.paper,
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      padding: theme.spacing(5, 6, 4, 6),
      width: "100%",
    },
    mainPanelContent: {
      [theme.breakpoints.up("xs")]: {
        width: "100%",
      },
      [theme.breakpoints.up("sm")]: {
        width: 328,
      },
      "@media (min-width: 1440px)": {
        width: 380,
      },
      margin: "auto",
      width: "100%",
    },
    root: {
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "560px 1fr",
      },
      "@media (min-width: 1440px)": {
        gridTemplateColumns: "780px 1fr",
      },
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: theme.spacing(3),
      height: "100vh",
      overflow: "hidden",
      position: "relative",
      width: "100vw",
    },
    sidebar: {
      [theme.breakpoints.up("lg")]: {
        alignItems: "center",
        display: "flex",
      },
      display: "none",
    },
    sidebarArt: {
      "& svg": {
        width: "100%",
      },
    },
  }),
  {
    name: "Layout",
  },
);
const Layout = (props: { children: ReactNode }) => {
  const { themeType } = useTheme();
  const { children } = props;
  const { errors } = useUser();
  const classes = useStyles(props);

  // show fullscreen loading when there is externalLoginError - we will redirect and
  // logout user in meantime
  if (errors.some(item => item === "externalLoginError")) {
    return <LoginLoading />;
  }



  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100vh"
      padding={10}
    >
      <img
        width={256}
        height="auto"
        src={themeType === "dark" ? wsmLogoLight : wsmLogoDark}
        alt="WSM Logo"
      />
      <p style={{ opacity: "60%" }}>powered by Saleor</p>

      <div className={classes.mainPanelContent}>{children}</div>
    </Box>
  );
};

Layout.displayName = "Layout";
export default Layout;
